import { Box, CircularProgress } from '@material-ui/core';
import { Webhook } from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { WebhooksTable } from '@/components/modules/Webhooks/components/WebhooksTable/WebhooksTable';
import { useWebhooks } from '@/components/modules/Webhooks/hooks/useWebhooks';
import { Font } from '@/components/shared/components/Font';
import { NemuruDialog } from '@/components/shared/components/NemuruDialog';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export interface DeleteWebhookDialogProps {
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  userId: string;
  webhook: Webhook;
}

export const DeleteWebhookDialog = ({ opened, setOpened, toggleDialog, userId, webhook }: DeleteWebhookDialogProps) => {
  const { deleteWebhook, loading } = useWebhooks(userId);

  const onDelete = async () => {
    await deleteWebhook(webhook.id);
    toggleDialog();
  };

  if (!userId || !webhook) return null;

  return (
    <NemuruDialog
      avoidDefaultClose
      opened={opened}
      setOpened={setOpened}
      buttons={
        <>
          <StandardButton disabled={loading} onClick={toggleDialog}>
            <Text tId={'CANCEL'} />
          </StandardButton>
          <StandardButton disabled={loading} main onClick={onDelete}>
            {loading ? <CircularProgress size={20} color={'secondary'} /> : <Text tId="DELETE" />}
          </StandardButton>
        </>
      }
      dialogProps={{
        maxWidth: 'md',
        fullWidth: true,
      }}
    >
      <>
        <Box mb={5}>
          <Font variant={'h3'} color={'title'}>
            <Text tId={'DELETE_WEBHOOK'} />
          </Font>
        </Box>
        <Box>
          <Font variant={'body2'} color={'textSecondary'}>
            <Text tId={'THE_FOLLOWING_WEBHOOK_WILL_BE_DELETED'} />
          </Font>
        </Box>
        <Box mt={4}>
          <WebhooksTable userId={userId} webhooks={[webhook]} deleteView />
        </Box>
      </>
    </NemuruDialog>
  );
};
